var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgLine = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23.803,
    viewBox: "0 0 18 23.803",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -14.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34 14)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14,19.485V5a1,1,0,0,1,2,0V20.961a1,1,0,0,1-1.371.929L11.06,20.465,8.939,21.594a2,2,0,0,1-1.879,0L4.94,20.465,1.371,21.889A1,1,0,0,1,0,20.961V1a1,1,0,0,1,1.445-.9L4.928,1.838,6.895.534a2,2,0,0,1,2.21,0l1.966,1.3L14.555.106a1,1,0,1,1,.89,1.791L11.962,3.629a2,2,0,0,1-2-.124L8,2.2,6.034,3.5a2,2,0,0,1-2,.124L2,2.615v16.87l2.2-.877a2,2,0,0,1,1.68.092L8,19.828,10.121,18.7a2,2,0,0,1,1.68-.092Z",
    transform: "translate(16 22.96) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1,2A1,1,0,0,1,1,0H7A1,1,0,0,1,7,2Z",
    transform: "translate(4 7.25)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30 22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3.2)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.009,3.3A5.568,5.568,0,0,1,14,3.207L11.039,2.2,8.077,3.207a5.568,5.568,0,0,1-3.007.1L2,2.521V15.538l3.312-.677a5.663,5.663,0,0,1,2.532.071l3.2.871,3.2-.871a5.663,5.663,0,0,1,2.532-.071Z",
    transform: "translate(-2 -2.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.631,2C.73,2,0,1.552,0,1S.73,0,1.631,0h9.784c.9,0,1.631.448,1.631,1s-.73,1-1.631,1Z",
    transform: "translate(2 3.007)"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/line.4e694b2e.svg";
export { ForwardRef as ReactComponent };